export const css = {
    root: 'IUFjeb5U',
    legend: '_1FCyh4RR',
    ' _key': 'apic-theme/dojo/radio-group'
};
export default css;
